import { useState } from 'preact/hooks';

import { translate } from '@vimeo/i18n-runtime';

import DismissButton from '../components/DismissButton';
import LiveBadge from '../components/LiveBadge';
import TrackThumbnail from '../components/TrackThumbnail';
import styles from './NextLiveClip.module.scss';

const NextLiveClip = (props) => {
  const { thumbnail, title } = props.clip;
  const [isShowing, setIsShowing] = useState(true);

  const launchLiveClip = (e) => {
    props.addNewLiveClip(props.clip);
    dismiss(e);
  };

  const dismiss = (e) => {
    e.stopPropagation();
    setIsShowing(false);
  };

  return isShowing ? (
    <div className={styles.nextLiveClipContainer} onClick={launchLiveClip}>
      <TrackThumbnail isPlaying={false} isSelected={false} url={thumbnail} />
      <div className={styles.playlistTrackDetails}>
        <div className={styles.playlistTrackClipTitle} title={title}>
          {title}
        </div>
        <div>
          <LiveBadge />
          <span className={styles.nextLiveClipStartingNow}>{translate('Click to watch')}</span>
        </div>
      </div>
      <DismissButton onClick={dismiss} />
    </div>
  ) : null;
};

export default NextLiveClip;
